import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '../../assets/styles/pages/market/market-page-mobile.scss';
// import Slider from '@/components/Slider/Slider';
import TabHeader from '@/components/TabHeader/TabHeader';
// import WatchlistMinimize from '@/components/Watchlist/WatchlistMinimize';
// import { getClassnameColorByValue } from '@/helpers/global';
import WatchlistMobile from '../../components/Watchlist/Watchlist.mobile';
import MarketInfoMobile from '../../components/Market/MarketInfo.mobile';
import MarketInfo from '@/components/Watchlist/MarketInfo'
import { WatchlistHelper } from '@/helpers/functions/watchlist.helper';
import  EditIcon  from '@/assets/images/icons/mobiles/icon_editwatchlist@2x.png'
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';

class MarketMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTabID:1,
            marketCode:'position',
            tabsWidth:''
        }
    }

    render() {
        const { language , topBarItem} = this.props;
        const { watchlistTab, sliderItems ,marketCode ,tabsWidth} = this.state;
        return (
            <React.Fragment>
                <div className='market-mobile-container'>
                    {(topBarItem?.id === 1 || !topBarItem) && <TabHeader tabs={watchlistTab} onChange={this.handleChangeWatchlistTab} />
                    
                        // <div className="outer-container">
                        //     <div className="inner-container">
                        //         <TabHeader tabs={watchlistTab} onChange={this.handleChangeWatchlistTab} />
                        //     </div>
                        // </div>
                    }
                    {(topBarItem?.id === 1) && <div className='watchlists-list-mobile'>
                        {<WatchlistMobile innerRef={e => this.watchlistRef = e} marketCode={marketCode} tabsWidth={tabsWidth}/>}
                        {/* {topBarItem && topBarItem.id === 2 && <MarketInfo innerRef={e => this.MarketInfoRef = e} />} */}
                        { <div className='edit-wathclist-btn' onClick={()=>{mobileSubLayoutAction.openMarketSet(tabsWidth,this.handleRefreshTable)}}>
                            <img src={EditIcon}></img>
                            <span>{language.mobile_edit_watchlists}</span>
                        </div> }
                    </div>}
                    {(topBarItem?.id === 2) && <div className='market-list-mobile'>
                        <MarketInfoMobile/>
                    </div>}
                </div>
            </React.Fragment>
        )
    }

    handleChangeWatchlistTab=(activeTab)=>{
        if(activeTab.main.id == this.state.currentTabID) return
        const marketCode = activeTab ? activeTab.main.value? activeTab.main.value : (activeTab.main.value==='' ? '': activeTab.main.name): '';
        this.setState({currentTabID:activeTab.main.id,marketCode})
        if(marketCode === 'position'){
            this.watchlistRef.getPostion()
        }else if(marketCode === ''){
            this.watchlistRef.getWatchLists()
        }else{
            this.watchlistRef.getWatchLists(marketCode)
        }
    }

    initTab=()=>{
        const { watchlist } = this.props
        if(!watchlist.preDefined) return
        const { custom } = watchlist
        const watchlistOptions = { position: true,  removeIcon: false , editIcon:false ,addIcon: false, removeState:false, addState:false,subTabValue:''}
        const tabs = WatchlistHelper.getTabHeader(custom, null, watchlistOptions, '', '', 1)
        this.setState({ watchlistTab: tabs },()=>{
            setTimeout(()=>{
                this.computedTabWidth()
            })
        })
    }

    computedTabWidth=()=>{
        if(this.state.watchlistTab){
           let tabs = document.getElementsByClassName('tab-header-container')[0].getElementsByClassName('main-tab-item')
           let tabsWidth = 0;
           for(let i=6;i<tabs.length;i++){
               tabsWidth += tabs[i].clientWidth
           }
           this.setState({tabsWidth})
        }
    }

    handleRefreshTable=()=>{
        const { marketCode } = this.state
        if(marketCode === 'position'){
            this.watchlistRef.getPostion()
        }else if(marketCode === ''){
            this.watchlistRef.getWatchLists()
        }else{
            this.watchlistRef.getWatchLists(marketCode)
        }
    }

    componentDidMount() {
        this.initTab()
    }
    componentDidUpdate(preProps){
        const { watchlist } =this.props
        if(preProps.watchlist.custom != watchlist.custom){
            this.initTab()
          }
    }
}

export default connect(
    state => ({
        language: state.app.language,
        watchlist :state.user.watchlist
    }),
    dispatch => ({

    })
)(MarketMobile)
